// extracted by mini-css-extract-plugin
export var auto = "_3v-1";
export var spinner = "_3v-0";